import { render, staticRenderFns } from "./BotaoCentralMensagensChat.vue?vue&type=template&id=15807757&scoped=true"
import script from "./BotaoCentralMensagensChat.vue?vue&type=script&lang=js"
export * from "./BotaoCentralMensagensChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15807757",
  null
  
)

export default component.exports